import { PushNotifications } from "@capacitor/push-notifications";
import { FirebaseMessaging } from "@capacitor-firebase/messaging"; // <--- IMPORTUJEMY FIREBASE
import { isPlatform } from "@ionic/react";
import { Capacitor } from "@capacitor/core";
import api from "../api/apiHelper";

// --- WSPÓLNA LOGIKA (Helper) ---
const addListeners = async () => {
  await PushNotifications.removeAllListeners();

  // Listener: Sukces rejestracji (Otrzymanie tokena)
  PushNotifications.addListener("registration", async (token) => {
    const platform = Capacitor.getPlatform();
    console.log(`PUSH: Event registration odebrany. Raw token: ${token.value}`);

    let finalToken = token.value;

    // --- FIX DLA IOS / FCM ---
    // Jeśli używasz Firebase do wysyłki, na iOS musisz pobrać token z pluginu Firebase,
    // bo 'token.value' tutaj to surowy APNs, którego FCM nie kuma.
    try {
        const result = await FirebaseMessaging.getToken();
        if (result && result.token) {
            finalToken = result.token;
            console.log("PUSH: Pomyślnie pobrano token FCM:", finalToken);
        }
    } catch (firebaseError) {
        console.warn("PUSH: Nie udało się pobrać tokena FCM, wysyłam surowy:", firebaseError);
        // Na Androidzie surowy zazwyczaj jest ok, na iOS to będzie problem, ale próbujemy
    }
    // -------------------------
    
    try {
      await api.post("/save-push-token/", { token: finalToken, platform: platform }, { skipLoading: true });
      console.log(`PUSH: Token (FCM) zapisany w bazie dla ${platform}.`);
    } catch (error) {
      console.error(`PUSH: Błąd API przy zapisie tokena:`, error);
    }
  });

  PushNotifications.addListener("registrationError", (error) => {
    console.error("PUSH: Błąd rejestracji:", JSON.stringify(error));
  });
};

// --- 1. FUNKCJA DLA POPUPA ---
export const registerForPushNotifications = async () => {
  if (!isPlatform("capacitor")) return;
  
  await addListeners();

  try {
    const permStatus = await PushNotifications.requestPermissions();
    if (permStatus.receive === 'granted') {
      PushNotifications.register();
    } else {
      console.warn("PUSH: Użytkownik odmówił zgody.");
    }
  } catch (err) {
    console.error("PUSH: Błąd requestPermissions:", err);
  }
};

// --- 2. FUNKCJA DLA APP.JS (CICHY SYNC) ---
export const syncPushTokenIfGranted = async () => {
  if (!isPlatform("capacitor")) return;

  try {
    const permStatus = await PushNotifications.checkPermissions();
    if (permStatus.receive === 'granted') {
      console.log("PUSH: Zgoda istnieje, odświeżam token w tle...");
      await addListeners();
      PushNotifications.register();
    }
  } catch (err) {
    console.error("PUSH: Błąd syncPushTokenIfGranted:", err);
  }
};

// --- 3. FUNKCJA DLA APP.JS (ODBIÓR WIADOMOŚCI) ---
export const setupPushMessageListeners = async () => {
  if (!isPlatform("capacitor")) return;

  await PushNotifications.addListener("pushNotificationReceived", (notification) => {
    console.log("PUSH: Otrzymano wiadomość (Foreground):", notification);
  });

  await PushNotifications.addListener("pushNotificationActionPerformed", (notification) => {
    console.log("PUSH: Kliknięto w powiadomienie:", notification);
  });
};
